import { render, staticRenderFns } from "./editstudents.vue?vue&type=template&id=a687452c"
import script from "./editstudents.vue?vue&type=script&lang=js"
export * from "./editstudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports